import { Injectable } from '@angular/core';

import {
  normalizePositiveInteger,
  normalizePositiveIntegerArray,
  normalizeStringValue,
  objectToQueryString,
} from '../../common/utils';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

export interface ResolutionSearchFilters {
  committeeActionStatusIds?: number[];
  committeeIds?: number[];
  conventionActionStatusIds?: number[];
  conventionId?: number | null;
  search?: string;
  typeId?: number;
  // PDF report only: one section per assigned committee
  groupByCommittee?: boolean;
}

@Injectable()
export class ResolutionService {
  constructor(private readonly rest: RestService) {}

  getResolutions(searchOrFilters: string | ResolutionSearchFilters = ''): Promise<any> {
    const query = objectToQueryString(this.normalizeSearchFilters(searchOrFilters));

    return this.rest.get(`${environment.apiUrl}/api/core/resolution${query}`);
  }

  getResolutionById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/resolution/${id}`);
  }

  getResolutionHistory(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/resolution/${id}/history`);
  }

  getResolutionVersions(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/resolution/${id}/versions`);
  }

  createResolution(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/resolution`, payload);
  }

  createNewVersion(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/resolution/!createNewVersion`, payload);
  }

  updateResolution(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/resolution/${id}`, payload);
  }

  private normalizeSearchFilters(searchOrFilters: string | ResolutionSearchFilters): ResolutionSearchFilters {
    const filters = typeof searchOrFilters === 'string' ? { search: searchOrFilters } : searchOrFilters || {};
    const normalizedCommitteeActionStatusIds = normalizePositiveIntegerArray(filters.committeeActionStatusIds);
    const normalizedCommitteeIds = normalizePositiveIntegerArray(filters.committeeIds);
    const normalizedConventionActionStatusIds = normalizePositiveIntegerArray(filters.conventionActionStatusIds);

    return {
      committeeActionStatusIds: normalizedCommitteeActionStatusIds.length ? normalizedCommitteeActionStatusIds : null,
      committeeIds: normalizedCommitteeIds.length ? normalizedCommitteeIds : null,
      conventionActionStatusIds: normalizedConventionActionStatusIds.length
        ? normalizedConventionActionStatusIds
        : null,
      conventionId: normalizePositiveInteger(filters.conventionId),
      search: normalizeStringValue(filters.search),
      typeId: normalizePositiveInteger(filters.typeId),
    };
  }
}
